<div class="dvb-betreuungsperson-kapazitaet">
    <div class="row">
        <div class="col-md-7 big-abstand-bottom">
            <dvb-fraktion-kapazitaet fraktion="vm.betreuungsPerson"></dvb-fraktion-kapazitaet>
        </div>
    </div>
</div>
